export function normalizeApiError(err) {
  if (!err?.response) {
    const msg = (String(err?.message || '')).toLowerCase()
    let userMsg = 'Error de red al contactar el servidor.'
    if (msg.includes('econnrefused')) {
      userMsg = 'No se puede conectar con el servidor (ECONNREFUSED). Verifica que el backend esté arriba.'
    } else if (msg.includes('network error')) {
      userMsg = 'No hay conexión con el servidor. ¿Hay internet/proxy?'
    } else if (msg.includes('timeout')) {
      userMsg = 'Tiempo de espera agotado al contactar el servidor.'
    }
    const e = new Error(userMsg)
    e.status = 0
    e.cause = err?.message || 'Network error'
    return e
  }

  const status = err.response.status
  const data = err.response.data
  const raw = Array.isArray(data?.message) ? data.message.join(' · ') : (data?.message || '')
  let userMsg = raw || 'Ha ocurrido un error en el servidor.'

  switch (status) {
    case 400:
      userMsg = (userMsg || 'Solicitud inválida')
        .replace(/must be longer than or equal to 8 characters/gi, 'debe tener al menos 8 caracteres')
        .replace(/must be an email/gi, 'debe ser un email válido')
      break
    case 401: userMsg = 'Correo o contraseña incorrectos'; break
    case 403: userMsg = 'Acceso denegado. Verifica tus permisos o credenciales.'; break
    case 404: userMsg = 'No se encontró el recurso solicitado o el servicio está bloqueado.'; break
    case 500: userMsg = raw || 'Error interno del servidor (500).'; break
    case 502: userMsg = 'Puerta de enlace inválida (502).'; break
    case 504: userMsg = 'Tiempo de espera de la puerta de enlace (504).'; break
    default:  userMsg = userMsg || `Error ${status}.`
  }

  const e = new Error(userMsg)
  e.status = status
  e.cause = (typeof data === 'string') ? data : (data?.error || data?.cause || null)
  e.payload = data
  return e
}
